import Renderer from "./renderer";

export default class {
  /** @type {Renderer} */
  defaultRenderer = undefined;
  /** @type {Set} */
  localizationKeys = undefined;

  constructor() {
    this.defaultRenderer = new Renderer();
    this.overwriteHelpers();
  }
  async render(template, context, options) {
    this.defaultRenderer.prepareRender(options);
    this.localizationKeys = new Set();
    this.wrapTranslateHelper();
    template = this.replacePropertiesWithPlaceholders(template);

    const compiled = this.defaultRenderer.handlebars.compile(template);
    return await this.defaultRenderer.postProcessOutput(
      compiled(context),
      options
    );
  }
  wrapTranslateHelper() {
    const self = this;
    const helper = this.defaultRenderer.handlebars.helpers["translate"];
    const wrapper = function(key, options) {
      self.localizationKeys.add(key);
      return helper(key, options);
    };
    this.defaultRenderer.handlebars.registerHelper("translate", wrapper);
  }

  overwriteHelpers() {
    this.defaultRenderer.handlebars.registerHelper("if", (condition, options) =>
      options.fn(this)
    );
    this.defaultRenderer.handlebars.registerHelper(
      "unless",
      (condition, options) => options.fn(this)
    );
    this.defaultRenderer.handlebars.registerHelper("each", (list, options) =>
      options.fn(this)
    );
    this.defaultRenderer.handlebars.registerHelper("with", (...args) =>
      args[args.length - 1].fn(this)
    );
  }

  replacePropertiesWithPlaceholders(template) {
    return template.replace(
      /\{{2,3}\s{0,4}((?!else)[\w[\].]*)\s{0,4}\}{2,3}/gm,
      "{$1}"
    );
  }
}
